var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',[_c('v-col',{staticClass:"text-center pa-5",attrs:{"md":"12"}},[_c('h1',[_vm._v("404")]),_c('h3',[_vm._v("This is not the page you are looking for :)")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }